import storiesStats from './stories.stats.html';
import detailedPublishWindow from './detailed-views/detailed-publish-window/content-publish-window.html';
import detailedDeadlineAccuracy from './detailed-views/detailed-deadline-accuracy/viz-deadline-accuracy.html';
import detailedStoryCount from './detailed-views/detailed-story-count/story-count.html';
import detailedPitchedStories from './detailed-views/detailed-pitched-stories/pitched-stories.html';

function mainStatsRoute($stateProvider, routeConfigProvider) {
  const params = {
    statsOverviewParams: '{pl:any}&{sec:any}',
    detailedView: {
      publishWindow: '{starting}&{ending}&{pi}&{live}&{so}',
      deadlineAccuracy: '{starting}&{ending}&{pi}&{so}',
      storyCount: '{starting}&{ending}&{pi:any}&{groupby}&{so}&{start}&{end}',
      pitchedStories: '{starting}&{ending}&{so}&{groupby}'
    }
  };
  $stateProvider
    .state('stats', {
      abstract: true,
      url: `/stats?${params.statsOverviewParams}`,
      params: routeConfigProvider.createRouteParams(params.statsOverviewParams),
      template: '<div ui-view></div>',
      resolve: {
        loadModule: [
          '$ocLazyLoad',
          ($ocLazyLoad) =>
            import('./stats').then((statsModule) => {
              $ocLazyLoad.load({ name: 'websked.stats' });
              return statsModule;
            })
        ],
        loadPlatforms: [
          'platformService',
          (platformService) => {
            platformService.getAll().then((platforms) => platforms);
          }
        ],
        distributors: [
          'distributorService',
          (distributorService) => distributorService.getByType('distributors')
        ]
      }
    })
    .state('stats.overview', {
      url: '/',
      controller: 'StoriesStatsController',
      data: {
        pageTitle: {
          de: 'Artikelstatistik',
          en: 'Story Stats',
          es: 'Estadísticas de los Artículos',
          fr: 'Statistiques d\u2019Articles'
        }
      },
      templateProvider() {
        return storiesStats;
      }
    })
    .state('stats.detailed-stats', {
      abstract: true,
      url: '',
      template: '<div ui-view></div>',
      data: {
        pageTitle: {
          de: 'Statistiken',
          en: 'Stats',
          es: 'Estadísticas',
          fr: 'Statistiques'
        }
      }
    })
    .state('stats.detailed-stats.publish-window', {
      url: `/publish-window?${params.detailedView.publishWindow}`,
      params: routeConfigProvider.createRouteParams(
        params.detailedView.publishWindow
      ),
      templateProvider() {
        return detailedPublishWindow;
      },
      controller: 'contentPublishWindowController',
      data: {
        pageTitle: {
          de: 'Inhalt pro Zeitabschnitt',
          en: 'Content Publish Window',
          es: 'Contenido por Periodo',
          fr: 'Fenêtre de Publication de Contenu'
        }
      },
      resolve: {
        enableRefresh() {
          return false;
        }
      }
    })
    .state('stats.detailed-stats.detailed-deadline-accuracy', {
      url: `/detailed-deadline-accuracy?${params.detailedView.deadlineAccuracy}`,
      params: routeConfigProvider.createRouteParams(
        params.detailedView.deadlineAccuracy
      ),
      templateProvider() {
        return detailedDeadlineAccuracy;
      },
      controller: 'StoriesController',
      data: {
        pageTitle: {
          de: 'Einhaltung der Frist im Detail',
          en: 'Detailed Deadline Accuracy',
          es: 'Precisión del Plazo en Detalle',
          fr: 'Précision de la Limite de Date Détaillée'
        }
      },
      resolve: {
        enableRefresh() {
          return false;
        }
      }
    })
    .state('stats.detailed-stats.story-count', {
      url: `/story-count?${params.detailedView.storyCount}`,
      params: routeConfigProvider.createRouteParams(
        params.detailedView.storyCount
      ),
      templateProvider() {
        return detailedStoryCount;
      },
      controller: 'StoriesController',
      data: {
        pageTitle: {
          de: 'Artikelanzahl',
          en: 'Story Count',
          es: 'Cantidad de Artículos',
          fr: 'Total d\u2019Articles'
        }
      },
      resolve: {
        enableRefresh() {
          return false;
        }
      }
    })
    .state('stats.detailed-stats.pitched-stories', {
      url: `/pitched-stories?${params.detailedView.pitchedStories}`,
      params: routeConfigProvider.createRouteParams(
        params.detailedView.pitchedStories
      ),
      templateProvider() {
        return detailedPitchedStories;
      },
      controller: 'StoriesController',
      data: {
        pageTitle: {
          de: 'Gepitchte Artikel',
          en: 'Pitched Stories',
          es: 'Artículos Vendidos',
          fr: 'Articles Soumis'
        }
      },
      resolve: {
        enableRefresh() {
          return false;
        }
      }
    });
}

export default function (ngModule) {
  ngModule.config(['$stateProvider', 'routeConfigProvider', mainStatsRoute]);
}
